module.exports = __webpack_public_path__ + "6bb8a7979120317b93588cd92c610fb5.svg";